import React from "react";
import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

const StatCard = ({ value, label, valueColor, cardStyles, valueSizes, labelSizes }) => {
  const isdark = useIsDark();

  return (
    <div
      className={twMerge(
        `
        w-full 
        min-w-[120px]
        mobile:w-[155px] 
        sm:w-[170px] 
        md:w-[133px] 
        tablet:w-[165px]  
        laptop:w-[165px]
        3xl:w-[230px]
        h-[120px]
        mobile:h-[125px]   
        sm:h-[140px] 
        md:h-[133px] 
        tablet:h-[133px] 
        laptop:h-[133px] 
        3xl:h-[198px] 
        rounded-xl
        flex
        flex-col
        items-center
        justify-center
        ${isdark ? "bg-[#2E2C40]" : "bg-[#D6D0FB]"}
      `,
        cardStyles
      )}
    >
      <div
        className={twMerge("font-alexandria font-semibold text-[30px] sm:text-[30px] md:text-[32px] xl:text-[36px] laptop:text-[40px] leading-tight mb-2", valueSizes)}
        style={{ color: valueColor }}
      >
        {value}
      </div>
      <div className={twMerge("text-center font-alexandria text-[#737373] font-normal text-[16px] tablet:text-[20px] xl:text-[20px] 3xl:text-[28px]", labelSizes)}>
        {label}
      </div>
    </div>
  );
};

const StatsCardsContainer = ({statsData ,gridStyles, cardStyles, valueSizes, labelSizes }) => {
  const DefaultstatsData =  [
    { value: "99.9%", label: "Uptime", valueColor: "  #3950D1" },
    { value: "24/7", label: "Support", valueColor: "#9C00BB" },
    { value: "50%", label: "Cost Saving", valueColor: "#0B9DCA" },
    { value: "500+", label: "Projects", valueColor: "#5F4EA0" },
  ];

  const stats =  statsData || DefaultstatsData;
  console.log(stats)

  return (
    <div
      className={twMerge("grid grid-cols-2 gap-10 p-10 rounded-lg", gridStyles)}
    >
      {stats.map((stat, index) => (
        <StatCard
          key={index}
          value={stat.value}
          label={stat.label}
          valueColor={stat.valueColor}
          cardStyles={cardStyles}
          valueSizes={valueSizes}
          labelSizes={labelSizes}
        />
      ))}
    </div>
  );
};

export default StatsCardsContainer;
